import { QueryClient, QueryCache, MutationCache } from "react-query";

export const queryCache = new QueryCache();
export const mutationCache = new MutationCache();

export const queryClient = new QueryClient({
    queryCache,
    mutationCache,
});
